import { QbBusiness as api } from '../../utils/business/qbbusiness'
import { push } from 'react-router-redux'

export const GET_TRACK_REQUEST = 'GET_TRACK_REQUEST'
export const GET_TRACK_SUCCESS = 'GET_TRACK_SUCCESS'
export const GET_TRACK_ERROR = 'GET_TRACK_ERROR'
export const getTrack = (id) => dispatch => {
	dispatch({ type: GET_TRACK_REQUEST })
	return api.getTrack(id)
		.then(response => {
			if (response.status === 'error') {
				dispatch(push('/'))
				dispatch({ type: GET_TRACK_ERROR, response })
			} else {
				dispatch({
					type: GET_TRACK_SUCCESS,
					track: response
				})
			}
		})
		.catch(e => {
			push('/')
			dispatch({ type: GET_TRACK_ERROR, e })
		})
}



// WEBPACK FOOTER //
// ./src/pages/track/trackActions.js